import { api } from '@/api/client';

export interface SystemSetting {
  key: string;
  value: number;
  default: number;
  minimum: number;
  maximum: number;
  updated_at: string | null;
}

export interface CleanupResult {
  retention_days: number;
  sessions: number;
  invites: number;
}

/** Setările instanței — serverul răspunde 403 oricui nu e admin global. */
export const systemApi = {
  list: () => api.get<SystemSetting[]>('/system-settings'),
  update: (key: string, value: number) =>
    api.put<SystemSetting>(`/system-settings/${key}`, { value }),
  runCleanup: () => api.post<CleanupResult>('/system-settings/cleanup', {}),
};
